import { FC } from 'react';
import { Box, Button, styled, Typography } from '@mui/material';

import { icons } from 'config/constants/assets';
import LaunchIcon from '@mui/icons-material/Launch';

const Container = styled(Box)(({ theme }) => ({
  position: 'relative',
  borderRadius: '20px',
  background: theme.palette.background.card,
  boxShadow:
    '0px 100px 77px rgba(0, 0, 0, 0.13), 0px 25.9935px 52.3711px rgba(0, 0, 0, 0.0989853), 0px 10.1608px 47.2956px rgba(0, 0, 0, 0.0902431), 0px 5.70356px 44.4605px rgba(0, 0, 0, 0.0829201), 0px 3.80638px 39.8596px rgba(0, 0, 0, 0.0717558), 0px 2.15748px 29.2214px rgba(0, 0, 0, 0.0505145)',

  [theme.breakpoints.up('xs')]: {
    padding: '0px 16px',
  },
  [theme.breakpoints.up('md')]: {
    padding: '0px 32px',
  },
}));

const PartnerName = styled(Typography)(({ theme }) => ({
    fontFamily: 'Prompt',
    fontStyle: 'normal',
    fontWeight: '700',
    cursor: 'pointer',
    fontSize: '19px',
    lineHeight: '29px',
  
    [theme.breakpoints.up('xs')]: {
      fontSize: '16px'
    },
    [theme.breakpoints.up('md')]: {
      display: 'block',
      fontSize: '19px'
    },
  }));

  const TokenImg = styled('img')(({ theme }) => ({
    width: '45px',
    borderRadius: '25px',
  }));

  const TokenImgSection = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    margin: '10px'
  }));

  const LinksSection = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    margin: '10px'
  }));

  const StyledButton = styled(Button)(({ theme }) => ({
    justifyContent: 'center',
    maxWidth: '30px'
  }));

const DiscordLinkImg = styled('img')(({ theme }) => ({
    width: '30px',
    height: '30px',
    fill: 'white',
    "&:hover": {
      filter: "brightness(0) saturate(100%) invert(28%) sepia(61%) saturate(2199%) hue-rotate(221deg) brightness(112%) contrast(98%)"
    }
  }));

  const TwitterLinkImg = styled('img')(({ theme }) => ({
      width: '30px',
      height: '30px',
      fill: 'white',
      "&:hover": {
        filter: "brightness(0) saturate(100%) invert(52%) sepia(34%) saturate(2512%) hue-rotate(178deg) brightness(93%) contrast(102%)"
      }
  }));

  const LinkImg = styled(LaunchIcon)(({ theme }) => ({
    width: '30px',
    height: '30px',
    fill: '#CDC392',
    "&:hover": {
      filter: "brightness(0) saturate(100%) invert(52%) sepia(34%) saturate(2512%) hue-rotate(178deg) brightness(93%) contrast(102%)"
    }
}));

interface PartnerCardProps {
  partnerInfo: any;
}

const PartnerCard: FC<PartnerCardProps> = ({ partnerInfo }) => {

  return (
    <>
        <Container>
            <Box display='flex' justifyContent='space-between' alignItems='center' sx={{minHeight: '40px', width: '100%'}}>
                <TokenImgSection>
                    <a
                        href={partnerInfo?.protocolSite}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <TokenImg alt="protocol" src={partnerInfo.protocolLogo} />
                    </a>
                    <PartnerName>
                        {partnerInfo.protocolName}
                    </PartnerName>
                </TokenImgSection>
                <LinksSection>
                <>
                    <a
                        href={partnerInfo?.twitterLink}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <TwitterLinkImg alt="token" src={icons.twitter} />
                    </a>
                    <a
                        href={partnerInfo?.discordLink}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <DiscordLinkImg alt="token" src={icons.discord} />
                    </a>
                    <a
                        href={partnerInfo?.protocolLinkSite}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <LinkImg  />
                    </a>
                </>
                </LinksSection>
            </Box>
        </Container>
    </>
  );
};

export default PartnerCard;
